/* eslint-disable */

export function dateFormater(time, formatter) {
    if (!time) {
        return "";
    }
    const dateObj = new Date(time);
    let fmt = formatter || "yyyy-MM-dd hh:mm:ss";
    const o = {
        "y+": dateObj.getFullYear(),
        "M+": dateObj.getMonth() + 1, // 月份
        "d+": dateObj.getDate(), // 日
        "h+": dateObj.getHours(), // 小时
        "m+": dateObj.getMinutes(), // 分
        "s+": dateObj.getSeconds(), // 秒
        "q+": Math.floor((dateObj.getMonth() + 3) / 3), // 季度
        "S+": dateObj.getMilliseconds() // 毫秒
    };
    for (const k in o) {
        if (new RegExp(`(${k})`).test(fmt)) {
            if (k == "y+") {
                fmt = fmt.replace(RegExp.$1, `${o[k]}`.substr(4 - RegExp.$1.length));
            } else if (k == "S+") {
                let lens = RegExp.$1.length;
                lens = lens == 1 ? 3 : lens;
                fmt = fmt.replace(
                    RegExp.$1,
                    `00${o[k]}`.substr(`${o[k]}`.length - 1, lens)
                );
            } else {
                fmt = fmt.replace(
                    RegExp.$1,
                    RegExp.$1.length == 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length)
                );
            }
        }
    }
    return fmt;
}

//补0操作
export function fillZero(num) {
    if (parseInt(num) < 10) {
        num = "0" + num;
    }
    return num;
}

export function getRemainingTime(start, end, needReload) {
    const time = end - start;
    let days = Math.floor(time / (24 * 3600 * 1000)); // 计算出天数
    let leavel = time % (24 * 3600 * 1000); // 计算天数后剩余的时间
    let hours = Math.floor(leavel / (3600 * 1000)); // 计算剩余的小时数
    let leavel2 = leavel % (3600 * 1000); // 计算剩余小时后剩余的毫秒数
    let minutes = Math.floor(leavel2 / (60 * 1000)); // 计算剩余的分钟数
    let seconds = Math.floor(time / 1000)
    if (needReload && (time <= 0 || (days <= 0 && hours <= 0 && minutes <= 0))) {
        window.location.reload();
        return {}
    }
    return {
        days,
        hours,
        minutes,
        seconds,
    };
}

export function transLateTime(date) {
    return new Date(date).getTime()
}